export default __webpack_public_path__ + "static/media/picture.dd4edd17.svg";